import { PACKAGES, packageByKey, packagePeriod } from "../lib/packages";
import { inr } from "../lib/api";

const inputCls = "w-full bg-[#0F0F0F] border border-white/10 text-white text-sm px-3 py-2.5 rounded-sm placeholder:text-white/30 focus:outline-none focus:border-[#D4AF37]";
const labelCls = "block text-[10px] uppercase tracking-widest text-white/40 mb-1.5";

// Controlled: plan = { package, package_start, group_fee, ... }
export const PackagePicker = ({ plan, setPlan, testid = "pkg", baseline = null }) => {
  const choose = (key) => {
    const pkg = packageByKey(key);
    const keep = (k) => (plan[k] === "" && baseline ? String(baseline[k] ?? "") : plan[k]);
    setPlan({ ...plan, package: key, group_fee: pkg ? String(pkg.price) : plan.group_fee,
      transport_fee: keep("transport_fee"), pt_fee: keep("pt_fee") });
  };
  const period = packagePeriod(plan.package, plan.package_start);
  return (
    <div className="col-span-2 sm:col-span-3 grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid={`${testid}-picker`}>
      <div className="col-span-2 sm:col-span-3">
        <label className={labelCls}>Billing</label>
        <div className="flex flex-wrap gap-2">
          <button type="button" onClick={() => choose("")} data-testid={`${testid}-standard`}
            className={`text-[11px] uppercase tracking-widest px-3 py-2 border rounded-sm transition-colors duration-200 ${!plan.package ? "border-[#D4AF37] bg-[#D4AF37]/15 text-[#D4AF37]" : "border-white/15 text-white/60 hover:border-white/40"}`}>
            Standard · 1st of month
          </button>
          {PACKAGES.map((p) => (
            <button key={p.key} type="button" onClick={() => choose(p.key)} data-testid={`${testid}-${p.key}`}
              className={`text-[11px] uppercase tracking-widest px-3 py-2 border rounded-sm transition-colors duration-200 ${plan.package === p.key ? "border-[#D4AF37] bg-[#D4AF37]/15 text-[#D4AF37]" : "border-white/15 text-white/60 hover:border-white/40"}`}>
              {p.label} · {inr(p.price)}
            </button>
          ))}
        </div>
      </div>
      {plan.package && (
        <>
          <div>
            <label className={labelCls}>Package Start Date *</label>
            <input required type="date" value={plan.package_start || ""} onChange={(e) => setPlan({ ...plan, package_start: e.target.value })} className={inputCls} data-testid={`${testid}-start`} />
          </div>
          <div className="col-span-2 sm:col-span-2 flex items-end">
            <p className="text-xs text-white/60 pb-2.5" data-testid={`${testid}-period`}>
              {period ? <>First cycle covers <span className="text-white">{period.from} – {period.to}</span> · Renews <span className="text-[#D4AF37]">{period.renews}</span></> : "Pick a start date to see the renewal date"}
            </p>
          </div>
        </>
      )}
    </div>
  );
};
